import script from "./CreateAccountPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateAccountPage.vue?vue&type=script&setup=true&lang=ts"

import "./CreateAccountPage.vue?vue&type=style&index=0&id=233c50c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233c50c2"]])

export default __exports__